import React from "react";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "./ui/select";

export const MODELS = [
    { provider: "gemini", model: "gemini-2.5-flash", label: "Gemini 2.5 Flash · fast & free" },
    { provider: "gemini", model: "gemini-3-flash-preview", label: "Gemini 3 Flash · newest" },
    { provider: "openai", model: "gpt-5.2", label: "GPT-5.2 · top quality" },
    { provider: "openai", model: "gpt-5-mini", label: "GPT-5 Mini · quick" },
    { provider: "anthropic", model: "claude-sonnet-4-5-20250929", label: "Claude Sonnet 4.5 · great writer" },
    { provider: "anthropic", model: "claude-haiku-4-5-20251001", label: "Claude Haiku 4.5 · zippy" },
];

export default function ModelSelector({ value, onChange }) {
    const current = MODELS.find(
        (m) => m.provider === value.provider && m.model === value.model
    ) || MODELS[0];

    return (
        <Select
            value={`${current.provider}:${current.model}`}
            onValueChange={(v) => {
                const [provider, ...rest] = v.split(":");
                const model = rest.join(":");
                onChange({ provider, model });
            }}
        >
            <SelectTrigger
                data-testid="model-selector"
                className="w-full h-12 nb-border nb-shadow-sm bg-white rounded-xl font-bold"
            >
                <SelectValue placeholder="Pick a model" />
            </SelectTrigger>
            <SelectContent className="nb-border rounded-xl">
                {MODELS.map((m) => (
                    <SelectItem
                        key={`${m.provider}:${m.model}`}
                        value={`${m.provider}:${m.model}`}
                        className="font-semibold"
                    >
                        {m.label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}
